import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import t from 'prop-types'

import {
  Grid,
  Form,
  Notifications,
  Loading,
} from 'components/UI'
import UserOrganizationList from './UserOrganizationList'
import UserBuildingList from './UserBuildingList'

const formFields = [
  { label: 'First Name', key: 'givenName' },
  { label: 'Last Name', key: 'familyName' },
  { label: 'Email', key: 'email' },
  { label: 'Phone', key: 'phone' },
]

class UserEdit extends Component {
  state = {
    textFields: {},
    mutationError: false,
  }

  handleOrgSelect = (organizationId) => {
    this.setState({
      organizationId,
    })
  }

  handleTextFieldChange = (key, value) => {
    this.setState({
      textFields: {
        ...this.state.textFields,
        [key]: value,
      }
    })
  }

  handleSubmit = () => {
    const {
      submit,
      onCancel,
      onSuccess,
      userId,
    } = this.props

    submit({
      ...this.state.textFields,
      userId,
    })
    .then(() => {
      onCancel()
      onSuccess()
    })
    .catch(error => this.setState({ mutationError: error.message }))
  }

  componentWillReceiveProps (nextProps) {
    const {
      error,
      loading,
      manager,
    } = nextProps.data

    if (error || loading) return

    this.setState({
      textFields: {
        ...manager,
      },
    })
  }

  render () {
    const { mutationError } = this.state

    const {
      data,
      onCancel,
    } = this.props

    const {
      error,
      loading,
      manager,
    } = data

    if (error) return <Notifications.Error message={error.message} />
    if (loading) return <Loading />

    return (
      <div>
        { mutationError && <Notifications.Error message={error} />}
        <Grid.Row>
          <Grid.Col><h3>LOCAL ADMIN:</h3></Grid.Col>
          <Grid.Col width={4}>
            { formFields.map(field => (
              <Form.Text
                key={field.key}
                label={field.label}
                value={this.state.textFields[field.key]}
                onChange={value => this.handleTextFieldChange(field.key, value)}
              />
            ))}
          </Grid.Col>
        </Grid.Row>
        <div>
          <Grid.Row>
            <h3>BUILDING ALLOCATION:</h3>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col>
              Company
              <UserOrganizationList selection={manager.organization.id} />
            </Grid.Col>
            <Grid.Col>
              Buildings
              <UserBuildingList organizationId={manager.organization.id} />
            </Grid.Col>
            <Grid.Col>
              <Form.Actions>
                <Form.Button onClick={onCancel}>
                  Cancel
                </Form.Button>
                <Form.Button onClick={this.handleSubmit}>
                  Save
                </Form.Button>
              </Form.Actions>
            </Grid.Col>
          </Grid.Row>
        </div>
      </div>
    )
  }
}

UserEdit.propTypes = {
  onSuccess: t.func.isRequired,
  onCancel: t.func.isRequired,
  userId: t.number.isRequired,
}

const UserEditQuery = gql`
  query UserEditQuery($userId: Int!) {
    manager(id: $userId) {
      givenName
      familyName
      email
      phone
      organization {
        id
        name
      }
    }
  }
`

const UserEditMutation = gql`
  mutation UserEditMutation(
    $userId: Int!,
    $givenName: String,
    $familyName: String,
    $email: String
    $phone: String,
  ) {
    updateManager(
      id: $userId,
      givenName: $givenName,
      familyName: $familyName,
      email: $email,
      phone: $phone
    ) {
      id
    }
  }
`

export default graphql(UserEditQuery, {
  options: {
    notifyOnNetworkStatusChange: true,
  },
})(graphql(UserEditMutation, {
    props: ({ mutate }) => ({
      submit: (variables) => mutate({ variables }),
    }),
  })(UserEdit))



// WEBPACK FOOTER //
// ./src/components/Profile/ManagerEdit.jsx